<template>
  <main-container>
    <a-card>
      <a-table
        row-key="id"
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template slot="action" slot-scope="record">
          <a @click="handleUpdateUsernameClick(record)">修改账号</a>
          <!--          <a-divider type="vertical"></a-divider>-->
          <!--          <a @click="handleUpdatePasswordClick(record)">修改密码</a>-->
        </template>
      </a-table>
    </a-card>
    <a-modal
      title="修改账号"
      :confirm-loading="updatingUsername"
      @ok="handleUpdateUsernameOk()"
      v-model="updateUsernameModalVisible"
    >
      <a-form-model
        ref="updateUsernameFormRef"
        :model="updateUsernameForm"
        :rules="updateUsernameFormRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="用户名" prop="username">
          <a-input v-model="updateUsernameForm.username" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      title="修改密码"
      :confirm-loading="updatingPassword"
      @ok="handleUpdatePasswordOk()"
      v-model="updatePasswordModalVisible"
    >
      <a-form-model
        ref="updatePasswordFormRef"
        :model="updatePasswordForm"
        :rules="updatePasswordFormRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="新密码" prop="new_pwd">
          <a-input v-model="updatePasswordForm.new_pwd" />
        </a-form-model-item>
        <a-form-model-item label="确认密码" prop="qr_pwd">
          <a-input v-model="updatePasswordForm.qr_pwd" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </main-container>
</template>

<script>
import Member from '@/api/member';

export default {
  name: 'SettingMember',
  data() {
    return {
      loading: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'num',
        },
        {
          title: '用户ID',
          dataIndex: 'id',
        },
        {
          title: '用户名',
          dataIndex: 'username',
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
        },
        {
          key: 'action',
          title: '操作',
          scopedSlots: { customRender: 'action' },
        },
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        'show-size-changer': true,
        'show-total': total => `共 ${total} 条`,
      },
      updateUsernameModalVisible: false,
      updateUsernameFormRules: {
        username: [{ required: true, message: '请输入用户名' }],
      },
      updateUsernameForm: {
        username: '',
      },
      updatingUsername: false,
      updatePasswordModalVisible: false,
      updatePasswordForm: {
        new_pwd: '',
        qr_pwd: '',
      },
      updatePasswordFormRules: {
        new_pwd: [{ required: true, message: '请输入新密码' }],
        qr_pwd: [{ required: true, message: '请确认密码' }, { validator: this.validateQrPwd }],
      },
      updatingPassword: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },

  mounted() {
    this.getMemberList();
  },

  methods: {
    validateQrPwd(rule, value, callback) {
      if (value !== this.updatePasswordForm.new_pwd) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getMemberList();
    },

    handleUpdateUsernameClick(record) {
      this.updateUsernameForm = {
        id: record.id,
        username: record.username,
      };
      this.updateUsernameModalVisible = true;
    },

    handleUpdateUsernameOk() {
      this.$refs.updateUsernameFormRef.validate(valid => {
        if (valid) {
          this.updatingUsername = true;
          Member.updateUsername(this.updateUsernameForm)
            .then(({ code }) => {
              if (code === 0) {
                this.$message.success('修改成功');
                this.updateUsernameModalVisible = false;
                this.getMemberList();
              }
            })
            .finally(() => {
              this.updatingUsername = false;
            });
        }
      });
    },

    handleUpdatePasswordClick(record) {
      this.updatePasswordForm = {
        id: record.id,
        new_pwd: '',
        qr_pwd: '',
      };
      this.updatePasswordModalVisible = true;
    },

    handleUpdatePasswordOk() {
      this.$refs.updatePasswordFormRef.validate(valid => {
        if (valid) {
          this.updatingPassword = true;
          Member.updatePassword(this.updatePasswordForm)
            .then(({ code }) => {
              if (code === 0) {
                this.$message.success('修改成功');
                this.updatePasswordModalVisible = false;
                this.getMemberList();
              }
            })
            .finally(() => {
              this.updatingPassword = false;
            });
        }
      });
    },

    getMemberList() {
      this.loading = true;

      Member.memberList({
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
      })
        .then(({ data }) => {
          this.pagination = {
            total: data.total_items,
            current: data.page,
            pageSize: data.page_limit,
          };
          this.dataSource = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
